// TODO: can define additional routes in here as needed

export const APP_BASE_ROUTE = '/';
